import { DeviceSupportedOSLabels } from 'client/util/Constants';
import moment from 'moment';
import windowsReleases from 'client/OsManagement/windowsReleases';

const { windows, linux, macos } = DeviceSupportedOSLabels;

export default {
  methods: {
    getPercentage(series, index, sum = '') {
      const total = series.reduce(
        (acc, item) => acc + parseInt(sum ? item[sum] : item, 10),
        0,
      );
      if (total === 0) {
        return '0%';
      }
      const value = parseInt(sum ? series[index][sum] : series[index], 10);
      const percentage = (value / total) * 100;
      return percentage < 1 ? '< 1%' : `${Math.round(percentage)}%`;
    },

    formatVersionName(os, version, includeLinuxReleaseName = true) {
      const osVersionParts = version.split(';');

      let osName = '';
      let osVersion = '';

      // Darwin
      if (os.includes(macos)) {
        osName = `macOS ${osVersionParts[1]}`;
        osVersion = `${osVersionParts[2]} (${osVersionParts[3]})`;
      }
      // Windows
      if (os.includes(windows)) {
        // We are getting the Windows name according to build number
        const buildNumber = String(osVersionParts[2]).split('.')[2];
        const windowsName = windowsReleases.find(win => win.build === buildNumber);

        if (windowsName) {
          osName = windowsName.name;
        } else {
          const auxWinVersion = String(osVersionParts[2]).split('.')[0];
          const auxBuildName = String(osVersionParts[1]);
          osName = `Windows ${auxWinVersion} Version ${auxBuildName}`;
        }
        osVersion = `${buildNumber}.${osVersionParts[3]}`;
      }
      // Linux
      if (os.includes(linux)) {
        // Linux distributions
        const linuxOsReleaseName = osVersionParts[1] ? `(${osVersionParts[1]})` : '';
        osVersion = `${osVersionParts[2]} ${osVersionParts[3]}`;
        osVersion = includeLinuxReleaseName ? `${osVersion} ${linuxOsReleaseName}` : osVersion;
      }

      return {
        name: osName || osVersionParts[0],
        version: osVersion || '',
      };
    },

    getEndOfServiceDate(os, version) {
      const osVersionParts = version.split(';');

      let endOfService = '';

      if (os.includes(windows)) {
        // We are getting the Windows name according to build number
        const buildNumber = String(osVersionParts[2]).split('.')[2];
        const windowsName = windowsReleases.find(win => win.build === buildNumber);
        endOfService = windowsName ? windowsName.endOfService : '';
      }

      return {
        endOfService: endOfService || '',
        days: moment(new Date()).diff(moment(new Date(endOfService)), 'days'),
      };
    },
  },
};
